<template>
    <table class="table" v-if="getLbilUsersListData">
        <thead>
            <tr>
                <th width="25%">Name</th>
                <th width="15%">Country</th>
                <th width="15%">City</th>
                <th width="15%">Gender</th>
                <th width="15%">DOB</th>
                <th width="15%" class="text-right">Joined Date</th>
            </tr>
        </thead>
        <tbody v-if="getLbilUsersListDataResults.length > 0">
            <tr v-for="item in getLbilUsersListDataResults" :key="item.id">
                <td>
                    <span class="member_user_avtaar">
                        <span>
                            <img v-if="item.profile.thumbnail" :src="item.profile.thumbnail" alt="" width="50">
                            <img src="@/assets/images/user2.png" v-bind:class="item.profile.thumbnail ? 'd-none' : ''"
                                alt="" width="50">
                        </span>
                    </span>
                    <span class="member_user_info">
                        <span class="member_user_name">
                            {{ item.first_name }} {{ item.last_name }}
                        </span>
                        <span class="member_user_email">{{ item.email }}</span>
                    </span>
                </td>
                <td>
                    <template v-if="item.profile.country">
                        <img :src="getCountryFlag(item.profile.country, 'flag')" class="country-flag" />
                        <span class="text-capitalize">{{ getCountryFlag(item.profile.country, 'name') }}</span>
                    </template>
                    <template v-else>
                        <img :src="getCountryFlag('in', 'flag')" class="country-flag" />
                        India
                    </template>
                </td>
                <td>
                    {{ item.profile.city }}
                </td>
                <td>
                    {{ item.gender }}
                </td>
                <td>
                    {{ item.dob | LocalDateFormat }}
                </td>
                <td class="text-right">
                    {{ item.date_joined | LocalDateFormat }}
                </td>
            </tr>
        </tbody>
        <tbody v-else>
            <tr>
                <td colspan="6" class="text-center pt-4">No Data Available</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
/*eslint-disable */
import countries from '@/services/country.json'
export default {
  name: 'lbil-users-list',
  components: {},
  props: [],
  data () {
    return {
      getLbilUsersListData:null,
      getLbilUsersListDataResults:[],
      countryList:[],
    }
  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.$store.dispatch('lbilAllUsersListAction').then((res) => {
        this.getLbilUsersListData = res.data.data;
        this.getLbilUsersListDataResults =  this.getLbilUsersListData.results;
    })
  },
  methods: {
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  },
}
</script>

<style lang="scss" scoped>
    .top_brd {
        border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .table {
        margin-bottom: 0;
        letter-spacing: 0.5px;
        color: #ffffff;

        thead th {
            border-bottom: 0;
            font-size: 16px;
            padding: 10px 5px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            text-transform: uppercase;
            border-top: 0px;

            &:first-child {
                padding-left: 0px;
            }

            &:last-child {
                padding-right: 0px;
            }
        }

        tbody {
            border-top:0px;
            td {
                color: #ffffff;
                vertical-align: middle;
                padding: 12px 5px;
                font-size: 16px;
                border-color: rgba(255, 255, 255, 0.1);
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
    
                &:first-child {
                    padding-left: 0px;
                }
    
                &:last-child {
                    padding-right: 0px;
                }
            }
        }

        a:hover {
            text-decoration: none;
        }

        .member_user_avtaar {
            display: inline-block;
            vertical-align: middle;

            img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                cursor: pointer;
            }
        }

        .member_user_info {
            display: inline-block;
            vertical-align: middle;
            width: calc(100% - 70px);
            margin-left: 10px;
        }

        .member_user_name {
            line-height: 1;
            font-size: 16px;
            color: #fff;
            display: block;
            cursor: pointer;

            a {
                color: #ffffff;
                text-decoration: none;
            }
        }

        .member_join_date {
            line-height: 1;
            font-size: 16px;
            color: #fff;
            display: block;
        }

        .member_user_email,
        .member_join_time {
            font-size: 15px;
            color: hsla(0, 0%, 100%, .5);
            white-space: pre-wrap;
            word-break: break-all;
            display: block;
        }

        .country-flag {
            width: 40px;
            display: inline-block;
            vertical-align: middle;
            margin-right: 5px;
        }

        .btn-success.member_user_video_call_btn {
            font-size: 14px;
            padding: 3px 10px;
            border-radius: 50px;
            outline: none;
            box-shadow: none;
            background: rgba(255, 255, 255, 0.1);
            color: #ffffff;
            border: none;

            &:hover {
                background: #87cefa;
                color: #000000;
            }
        }
    }

    .main_heading {
        color: #ffffff;
        font-size: 28px;
        text-transform: uppercase;
        font-weight: bold;
        margin: 0px;
    }

    .btn-primary {
        cursor: pointer;
        box-shadow: none !important;
        outline: none !important;

        &:hover {
            background: #87cefa;
            color: #000;
            border-color: #87cefa;
        }
    }

    .action_list {
        display: flex;
        margin: 0;
        justify-content: flex-end;
        padding-right: 3px;

        li {
            margin-left: 10px;

            &:first-child {
                margin-left: 0px;
            }

            .btn {
                padding: 2px 8px;
            }
        }
    }

    .lbil_doctor_info_modal {
        position: fixed;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.92);
        left: 0;
        right: 0;
        z-index: 1000;
        min-height: 100dvh;
        width: 100%;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 8px;
            background: transparent;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #333333;
        }
    }

    .lbil_doctor_info_modal_body {
        background: #000;
        width: 480px;
        margin: 0px auto;
        border-radius: 5px;
        padding: 20px 25px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        color: #ffffff;
        -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    }
    .lbil_doctor_info_modal_wrp{
        display: table;
        width: 100%;
        height: 100%;
    }
    .lbil_doctor_info_modal_center{display:table-cell;vertical-align:middle;}
    .remove_data_task_header h2 {
        font-size: 18px;
        color: #ffffff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        text-align: center;
        margin: 0 0 30px;
    }

    .remove_yes_btn {
        font-size: 16px;
        background: rgba(255, 18, 18, 0.5);
        color: #fff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        padding: 10px 5px;
        min-width: 100px;
        line-height: 1;
        border-radius: 3px !important;
        outline: none !important;
        box-shadow: none !important;
        &:hover {
            background: #ffe738 !important;
            color: #22292f !important;
        }
    }

    .remove_yes_no {
        font-size: 16px;
        background: rgba(33, 228, 0, 0.5);
        color: #fff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        padding: 10px 5px;
        min-width: 100px;
        line-height: 1;
        margin-left: 15px;
        border-radius: 3px !important;
        outline: none !important;
        box-shadow: none !important;
        &:hover {
            background: #ffe738 !important;
            color: #22292f !important;
        }
    }

    .remove_data_task_btn {
        text-align: center;
    }

    .remove_data_task_btn {
        text-align: center;
    }

    .custom_round_switch {
        vertical-align: middle;
        margin-bottom: 0;
        margin-top: 3px;

        span {
            width: 20px;
            height: 20px;
            background: #da1b22;
            cursor: pointer;
            position: relative;
            display: inline-block;
            vertical-align: middle;
            border-radius: 50%;

            &:before {
                content: "";
                width: 10px;
                height: 10px;
                background: #fff;
                position: absolute;
                margin: auto;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                border-radius: 50%;
            }
        }
    }

    input[type=checkbox].checked+.custom_round_switch span {
        background: #36b04c;
    }

    .load_more_btn {
        color: #fff !important;
        background: rgba(255, 255, 255, 0.1);
        padding: 5px;
        min-width: 110px;
        font-size: 16px;
        border-radius: 3px;
        border: 0 !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        margin: 15px 0;
    }

    .load_more_btn:hover {
        color: #000 !important;
        background: #87cefa;
    }

    /* Toggle button styles */
    .onoffswitch {
        position: relative;
        width: 55px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
    }

    .onoffswitch-checkbox {
        display: none;
    }

    .onoffswitch-label {
        display: block;
        overflow: hidden;
        cursor: pointer;
        border: 0px solid #999999;
        border-radius: 20px;
    }

    .onoffswitch-inner {
        display: block;
        width: 200%;
        margin-left: -100%;
        transition: margin 0.3s ease-in 0s;
    }

    .onoffswitch-inner:before,
    .onoffswitch-inner:after {
        display: block;
        float: left;
        width: 50%;
        height: 25px;
        padding: 0;
        line-height: 25px;
        font-size: 13px;
        color: white;
        font-weight: bold;
        box-sizing: border-box;
    }

    .onoffswitch-inner:before {
        content: "";
        padding-left: 10px;
        background-color: #36B04C;
        color: #FFFFFF;
    }

    .onoffswitch-inner:after {
        content: "";
        padding-right: 10px;
        background-color: #DA1B22;
        color: #FFFFFF;
        text-align: right;
    }

    .onoffswitch-switch {
        display: block;
        width: 17px;
        margin: 4px;
        background: #FFFFFF;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 31px;
        border: 0px solid #999999;
        border-radius: 13px;
        transition: all 0.3s ease-in 0s;
    }

    .onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-inner {
        margin-left: 0;
    }

    .onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-switch {
        right: 0px;
    }

    .user_event_info {
        margin-top: 10px;
        display: block;

        .btn-primary {
            padding: 1px 8px;
            font-size: 13px;
            border-radius: 50px;
            background: rgba(255, 255, 255, 0.1);
            color: #ffffff;
            border: none;
            margin-right: 5px;

            &:hover {
                background: #87cefa;
                color: #000000;
            }
        }
    }

    .user_not_connected_popup h3 {
        font-size: 20px;
        letter-spacing: 0;
        text-align: center;
    }

    .user_not_connected_popup .lbil_doctor_info_modal_body {
        padding: 50px 30px;
        margin: 15vh auto 0;
        width: 500px;
        text-align: center;
    }

    .connected_user_info_popup {
        .lbil_doctor_info_modal_body {
            width: 560px !important;
            position: relative;

            h3 {
                font-size: 22px;
                letter-spacing: 0;
                margin-bottom: 15px;
            }

            .connected_user_info_closed_icon {
                position: absolute;
                top: 5px;
                right: 8px;
                line-height: 1;

                .fa {
                    font-size: 20px;
                    color: red;
                    cursor: pointer;
                    transform: scale(1);
                    -webkit-transform: scale(1);
                    -moz-transform: scale(1);
                    transition: all ease 0.5s;

                    &:hover {
                        transform: scale(1.1);
                        -webkit-transform: scale(1.1);
                        -moz-transform: scale(1.1);
                    }
                }
            }
        }
    }

    .request_send_popup .form-control {
        background: rgba(255, 255, 255, 0.1) !important;
        border: none;
        color: #fff;
    }

    .request_send_popup h3 {
        font-size: 22px;
        letter-spacing: 0;
    }

    .badge {
        font-weight: normal;
        font-size: 13px;
        margin-bottom: 0px;
    }

    .request_send_popup .lbil_doctor_info_modal_body {
        text-align: center;
    }

    .add_user_btn {
        cursor: pointer;
        position: relative;
        min-width: 95px;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        outline: none !important;
        background: rgba(255, 255, 255, 0.2);
        color: #ffffff;
        border: none;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;

        &:hover {
            background: #87cefa;
            color: #000;
            border-color: #87cefa;
        }
    }

    .delete_users_wrp h5 {
        margin: 0;
        font-size: 22px;
        padding: 15px 0;
        font-weight: 700;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        text-transform: uppercase;
        color: #fbfbd6;
    }

    .table_section_heading h5 {
        margin: 0;
        font-size: 22px;
        padding: 15px 0;
        font-weight: 700;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        text-transform: uppercase;
        color: #fbfbd6;
    }

</style>